import { render, staticRenderFns } from "./NotificarErrosSlack.vue?vue&type=template&id=8b7626f2&scoped=true&"
import script from "./NotificarErrosSlack.vue?vue&type=script&lang=js&"
export * from "./NotificarErrosSlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7626f2",
  null
  
)

export default component.exports